import { CheckCircle, MessageCircle, ArrowLeft } from "lucide-react";
import { motion } from "framer-motion";

const ThankYou = () => {
  return (
    <div className="min-h-screen bg-background flex items-center justify-center px-6">
      <motion.div
        initial={{ opacity: 0, y: 30 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.6 }}
        className="text-center max-w-lg"
      >
        <div className="flex items-center justify-center w-20 h-20 rounded-full bg-primary/10 mx-auto mb-6">
          <CheckCircle className="w-10 h-10 text-primary" />
        </div>

        <h1 className="text-3xl md:text-4xl font-bold text-foreground mb-4">
          Pagamento confirmado!
        </h1>

        <p className="text-muted-foreground text-lg mb-2">
          Obrigado por confiar na <span className="text-primary font-semibold">Ad4You Pages</span>.
        </p>

        <p className="text-muted-foreground text-sm mb-8">
          Nossa equipe entrará em contato em breve para dar início ao seu projeto.
          Fique atento ao seu WhatsApp e e-mail.
        </p>

        <div className="flex flex-col sm:flex-row items-center justify-center gap-4">
          <a
            href="https://wa.me/5519988278133?text=Olá,%20acabei%20de%20realizar%20o%20pagamento%20e%20quero%20iniciar%20meu%20projeto!"
            target="_blank"
            rel="noopener noreferrer"
            className="inline-flex items-center gap-2 px-6 py-3 rounded-xl bg-[#25D366] text-white font-semibold text-sm hover:opacity-90 transition-all"
          >
            <MessageCircle className="w-4 h-4" />
            Falar no WhatsApp
          </a>

          <a
            href="/"
            className="inline-flex items-center gap-2 px-6 py-3 rounded-xl glass hover:bg-muted text-foreground font-semibold text-sm transition-all"
          >
            <ArrowLeft className="w-4 h-4" />
            Voltar ao site
          </a>
        </div>
      </motion.div>
    </div>
  );
};

export default ThankYou;
